import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

export const handleDialogDeleted = async (ctxData: WebSocketMessage) => {
  if (ctxData.dialog_deleted_event?.contact_hid) {
    const { removeDialog } = useDialogsStore.getState();

    try {
      await removeDialog({ hid: ctxData.dialog_deleted_event?.contact_hid });
    } catch (e) {
      catchErrors(e);
    }
  }
};
